export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

export interface LogContext {
  [key: string]: unknown;
}

export interface Logger {
  debug(message: string, context?: LogContext): void;
  info(message: string, context?: LogContext): void;
  warn(message: string, context?: LogContext, error?: unknown): void;
  error(message: string, context?: LogContext, error?: unknown): void;
  withContext(context: LogContext): Logger;
}

const noopLogger: Logger = {
  debug() {},
  info() {},
  warn() {},
  error() {},
  withContext: () => noopLogger,
};

let active: Logger = noopLogger;

export function setLogger(logger: Logger): void {
  active = logger;
}

export function getLogger(): Logger {
  return active;
}

export function resetLogger(): void {
  active = noopLogger;
}
